import { isEmptyObject } from "../../../utils/tests";
import { LmpHeroStickyQuery, LmpHeroStickySubscription } from '../types';

/**
 * typeguard for LmpHeroStickyQuery
 * @param LmpHeroStickyQuery object passed to transformer
 */
export const isValidLmpHeroStickyQuery = (obj: LmpHeroStickyQuery): boolean => Boolean(obj?.data?.getLmpHeroSticky && !isEmptyObject(obj.data.getLmpHeroSticky));

/**
 * typeguard for LmpHeroStickySubscription
 * @param LmpHeroStickySubscription object passed to transformer
 */
export const isValidLmpHeroStickySubscription = (obj: LmpHeroStickySubscription): boolean => Boolean(obj?.data?.onUpdateLmpHeroStickyByMatchId && !isEmptyObject(obj.data.onUpdateLmpHeroStickyByMatchId));
